export const REFUND_TABLE_HEADERS = ['No', 'Market', 'Name','Date', 'Refund reason', 'Amount', 'Currency','Status', 'Actions'];
